<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">New Reward Bonus</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="row gy-4">
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Cash/Bank Account:*</label>
                                                        <div class="form-control-wrap">
                                                            <accountdropdown v-model="newPaymentVoucher.cashBankAccountId" :prop="'CashBank'" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label">User Account:*</label>
                                                        <div class="form-control-wrap">
                                                            <userdropdown v-model="newPaymentVoucher.userId" :values="newPaymentVoucher.userId" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label" for="default-01">Amount</label>
                                                        <div class="form-control-wrap">
                                                            <input v-model="newPaymentVoucher.amount" type="number" class="form-control" id="default-01">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div class="form-group">
                                                        <label class="form-label">Narration</label>
                                                        <div class="form-control-wrap">
                                                            <textarea v-model="newPaymentVoucher.description" type="text" class="form-control"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;"> Save</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default ({
        components: {
            Loading
        },
        name: 'newPaymentVoucher',
        data: function () {
            return {
                loading: false,
                newPaymentVoucher: {
                    id: '00000000-0000-0000-0000-000000000000',
                    description: '',
                    cashBankAccountId: '',
                    userId: '',
                    amount: 0,
                }
            }
        },
        validations: {
            newPaymentVoucher:
            {
                cashBankAccountId:
                {
                    required
                },
                userId:
                {
                    required
                },
                amount:
                {
                    required
                }
            }
        },

        methods: {
            getImage: function (path) {
                this.newPaymentOption.image = path;
            },

            GoToList: function () {
                this.$router.push('/PaymentVouchers')
            },

            SaveNewUser: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                debugger;
                root.$https.post('/Accounting/SavePaymentVoucher', this.newPaymentVoucher, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Added!',
                                text: 'Data has been Saved successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-danger",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

        },
        created: function () {

            if (this.$route.query.data != undefined) {
                this.newPaymentVoucher = this.$route.query.data;
            }
        },
    })
</script>
